var exports = {
  "Zd": "DateOfBirthGate.module__form___RWVhbW",
  "DD": "DateOfBirthGate.module__title___RWVhbW",
  "h_": "DateOfBirthGate.module__description___RWVhbW",
  "qr": "DateOfBirthGate.module__footer___RWVhbW",
};

module.exports = exports;
